import { render, staticRenderFns } from "./BrandVehicle.vue?vue&type=template&id=331e2458"
import script from "./BrandVehicle.vue?vue&type=script&lang=js"
export * from "./BrandVehicle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports